import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const PrintTemplatesList = Loadable(
  lazy(() =>
    import("./PrintTemplatesList").then(({ PrintTemplatesList }) => ({
      default: PrintTemplatesList,
    })),
  ),
);

const OutletTemplatesList = Loadable(
  lazy(() =>
    import("./OutletTemplatesList").then(({ OutletTemplatesList }) => ({
      default: OutletTemplatesList,
    })),
  ),
);

export const printTemplatesRoutes = [
  {
    path: "/print-templates",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_TEMPLATES]}>
        <PrintTemplatesList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/templates",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.TEMPLATES]}>
        <OutletTemplatesList />
      </AuthorizedRoute>
    ),
  },
];
